/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2018 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  'use strict';

  // Use behaviors with context variable.
  Drupal.behaviors.railNav = {
    attach: function(context) {

      var $navItem = $('.rail-nav-drawer li');
      $(once('railNav', $navItem)).each(
        function() {
          $(this).on('click', function(e) {
            e.stopPropagation();
            $(this).toggleClass('is-open');
            $(this).toggleClass('is-active');
          })
        }
      )

      // Show/hide rail nav class based on viewport
      $(window).on('resize load reload', function() {
        if ( $(window).width() < 900 ) {
          $('.rail-nav--trigger, .rail-nav-drawer').addClass('is-close');
        } else {
          $('.rail-nav--trigger, .rail-nav-drawer').removeClass('is-close');
        }

        // Create railItem variable
        var $railItem = $('.rail-nav__item', context).one('railIsActive');

        // Check all rail items on page
        $railItem.each(function() {
          // If rail item has class
          if ($(this).hasClass('is-active')) {
            // Add active path class to parents of nested active page
            $(this).parents('.rail-nav__item').addClass('is-active-path');
          }

        });
      });

      // Rail stuff.
      $('.rail-nav--trigger', context).one('railTrigger').click(function() {
        if ($(this).hasClass('is-close')) {
          console.log('open');
          $(this).removeClass('is-close');
          $('.rail-nav-drawer').removeClass('is-close');
        } else {
          console.log('close');
          $(this).addClass('is-close');
          $('.rail-nav-drawer').addClass('is-close');
        }
      });

      $('.rail-nav-sub--trigger', context).one('railSubTrigger').click(function() {
        if ($(this).parent().hasClass('is-open')) {
          $(this).parent().removeClass('is-open');
        } else {
          $(this).parent().addClass('is-open');
        }
      });

    }
  };

})(jQuery, Drupal, once);
